import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { RecoverBigDataQuestionTypes } from '../Types';

const machine = Machines.onRecoverBigDataQuestion.machine;

export const recoverBigDataQuestion = (
  params: RecoverBigDataQuestionTypes.RecoverBigDataQuestionServiceRequestType,
): Promise<RecoverBigDataQuestionTypes.IRecoverBigDataQuestionServiceResponse> => {
  return callServiceMachine(machine, params);
};

export default { recoverBigDataQuestion };
